import { Product } from './product';

export class ProductSelectDialog {
  excludeProductIds: Array<string>;
  includeModels: Array<string>;
  providerId: string;
  selectLimit: number;
}
